import { type SxProps, type Theme } from "@mui/material";

import { Avatar } from "../Avatar";
import { Chip } from "./Chip";

export interface UserChipProps {
  label: string;
  avatar?: {
    src?: string;
    fallback?: string;
  };
  onRemove?: () => void;
  disabled?: boolean;
  sx?: SxProps<Theme>;
}

/**
 * A chip component for displaying a user with avatar.
 * Wraps the base Chip component with avatar support.
 */
export function UserChip(props: UserChipProps) {
  const { label, avatar, onRemove, disabled = false, sx } = props;

  return (
    <Chip disabled={disabled} label={label} sx={sx} onRemove={onRemove}>
      {avatar && (
        <Avatar
          alt={label}
          disabled={disabled}
          size="small"
          src={avatar.src}
          sx={{
            width: 20,
            height: 20,
            fontSize: "0.625rem",
          }}
        >
          {avatar.fallback}
        </Avatar>
      )}
    </Chip>
  );
}
